import { css as _css4 } from 'emotion';
import { css as _css3 } from 'emotion';
import { css as _css2 } from 'emotion';
import _extends from 'babel-runtime/helpers/extends';
import { css as _css } from 'emotion';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React, { Fragment } from 'react';
import { components } from 'react-select';

import { colors } from '@atlaskit/theme';
import SearchIcon from '@atlaskit/icon/glyph/editor/search';

// ==============================
// Styled Components
// ==============================

var MenuDialog = function MenuDialog(_ref) {
  var maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      props = _objectWithoutProperties(_ref, ['maxWidth', 'minWidth']);

  var shadow = colors.N40A;
  return React.createElement('div', _extends({
    className: _css({
      backgroundColor: 'white',
      borderRadius: 4,
      boxShadow: '0 0 0 1px ' + shadow + ', 0 4px 11px ' + shadow,
      maxWidth: maxWidth,
      minWidth: minWidth,
      zIndex: 2
    })
  }, props));
};

// ==============================
// Custom Components
// ==============================

export { MenuDialog };
var _ref2 = { marginRight: 2, textAlign: 'center', width: 32 };
var DropdownIndicator = function DropdownIndicator() {
  return React.createElement(
    'div',
    {
      className: _css2(_ref2)
    },
    React.createElement(SearchIcon, null)
  );
};
var _ref4 = { padding: '8px 8px 4px' };
var Control = function Control(_ref3) {
  var _ref3$innerProps = _ref3.innerProps,
      innerRef = _ref3$innerProps.innerRef,
      innerProps = _objectWithoutProperties(_ref3$innerProps, ['innerRef']),
      props = _objectWithoutProperties(_ref3, ['innerProps']);

  return React.createElement(
    'div',
    { ref: innerRef, className: _css3(_ref4)
    },
    React.createElement(components.Control, _extends({}, props, { innerProps: innerProps }))
  );
};
var _ref5 = {
  border: 0,
  clip: 'rect(1px, 1px, 1px, 1px)',
  height: 1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: 1
};
export var DummyControl = function DummyControl(props) {
  return React.createElement(
    'div',
    {
      className: _css4(_ref5)
    },
    React.createElement(components.Control, props)
  );
};
// NOTE `props` intentionally omitted from `Fragment`
// eslint-disable-next-line
var Menu = function Menu(_ref6) {
  var key = _ref6.key,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ['key', 'children']);

  return React.createElement(
    Fragment,
    { key: key },
    children
  );
};
export var defaultComponents = { Control: Control, DropdownIndicator: DropdownIndicator, Menu: Menu };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/select/dist/esm/PopupSelect/components.js
// module id = 1284
// module chunks = 0